import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearNavigation } from "../../store/reducers/navigateReducer.js";

const NavigationListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const redirectTo = useSelector((state) => state.navigation.redirectTo);

  useEffect(() => {
    if (redirectTo && location.pathname !== redirectTo) {
      navigate(redirectTo, { replace: true });
      dispatch(clearNavigation());
    }
  }, [redirectTo, location.pathname, navigate, dispatch]);

  return null;
};

export default NavigationListener;
